import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

interface GenericFormControlProps<T> {
  value: T;
  onChange: (event: SelectChangeEvent<T>) => void;
  options: Array<{ value: T; label: string; id?: string; disabled?: boolean }>;
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

const GenericFormControl = <T extends string>({
  value,
  onChange,
  options,
  className,
  fullWidth = true,
  disabled = false,
}: GenericFormControlProps<T>) => {
  return (
    <FormControl fullWidth={fullWidth}>
      <Select value={value} onChange={onChange} className={className} disabled={disabled}>
        {options.map((option, idx) => (
          <MenuItem
            key={option.id || `option-${value}-${idx}`}
            id={option.id}
            value={option.value}
            className={option.id}
            disabled={option.disabled}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default GenericFormControl;
